<template>
    <button class="paypal-btn">
        <img :src="`${staticPath}static/images/paypal.png`">
    </button>
</template>

<script setup>
    const staticPath = process.env.BASE_URL
</script>

<style scoped>
    .paypal-btn {
        display: inline-block;
        padding: 3px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #333;
        background-color: #fff;
        border-color: #ccc;
    }

    .paypal-btn:hover {
        color: #333;
        background-color: #e6e6e6;
        border-color: #adadad;
    }
</style>